import Vue from 'vue';
import Router from 'vue-router';
import Home from '../../views/pages/Home.vue';
import About from '../../views/pages/About.vue';
import Team from '../../views/pages/Team.vue';
import Faqs from '../../views/pages/Faqs.vue';
import Community from '../../views/pages/Community'
import HowWeWork from '../../views/pages/HowWeWork'
import FocusArea from '../../views/pages/area-of-focus/FocusArea'
import LabMakerSpace from '../../views/pages/area-of-focus/research/LabMakerSpace'
import ResearcherConnect from '../../views/pages/area-of-focus/research/ResearcherConnect'
import ResearchCommercialization from '../../views/pages/area-of-focus/research/ResearchCommercialization'
import StartupStudio from '../../views/pages/area-of-focus/venture-building/StartupStudio'
import TribinnovIncubator from '../../views/pages/area-of-focus/venture-building/TribinnovIncubator'
import InnovationLabs from '../../views/pages/area-of-focus/venture-building/InnovationLabs'
import CoopFund from '../../views/pages/area-of-focus/funding/CoopFund'
import TribinnovCapital from '../../views/pages/area-of-focus/funding/TribinnovCapital'
import InvestmentSummit from '../../views/pages/area-of-focus/funding/InvestmentSummit'
import TalentDevelopment from '../../views/pages/area-of-focus/complementary-solutions/TalentDevelopment'
import DataCollection from '../../views/pages/area-of-focus/complementary-solutions/DataCollection'
import InnovationDistribution from '../../views/pages/area-of-focus/complementary-solutions/InnovationDistribution'
// import Blog from '../../views/pages/blog/Blog'
// import SinglePost from '../../views/pages/blog/SinglePost'


Vue.use(Router);

const IndexRoutes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/home',
        component: Home
    },
    {
        path: '/team',
        component: Team
    },
    {
        path: '/about',
        component: About
    },
    {
        path: '/faqs',
        component: Faqs
    },
    {
        path: '/community',
        component: Community
    },
    {
        path: '/how-we-work',
        component: HowWeWork
    },
    {
        path: '/focus',
        component: FocusArea
    },
    {
        path: '/focus/research/lab-maker-spaces',
        component: LabMakerSpace
    },
    {
        path: '/focus/research/research-connect',
        component: ResearcherConnect
    },
    {
        path: '/focus/research/research-commercialization',
        component: ResearchCommercialization
    },
    {
        path: '/focus/venture-building/startup-studio',
        component: StartupStudio
    },
    {
        path: '/focus/venture-building/tribinnov-incubator',
        component: TribinnovIncubator
    },
    {
        path: '/focus/venture-building/campus-innovation-labs',
        component: InnovationLabs
    },
    {
        path: '/focus/funding/coop-fund',
        component: CoopFund
    },
    {
        path: '/focus/funding/tribinnov-capital',
        component: TribinnovCapital
    },
    {
        path: '/focus/funding/africa-investment-summit',
        component: InvestmentSummit
    },
    {
        path: '/focus/complementary-solutions/talents-development',
        component: TalentDevelopment
    },
    {
        path: '/focus/complementary-solutions/data-collection-and-analytics',
        component: DataCollection
    },
    {
        path: '/focus/complementary-solutions/innovations-distribution',
        component: InnovationDistribution
    },
//     {
//         path: '/blog',
//         component: Blog
//     },
//     {
//         name: 'single-post',
//         path: '/blog/posts/:slug',
//         component: SinglePost
//     },
]


export default IndexRoutes